<!-- Vista: formulario de login -->
<div
  *ngIf="!user"
  [@fadeSlide]
  class="login-page"
>
  <div class="login-content">
    <sw-user-login-form
      [isLoading]="isLoginLoading"
      (loginSubmit)="onLoginSubmit($event)"
      (forgotPassword)="onForgotPassword($event)"
    ></sw-user-login-form>
  </div>
</div>

<!-- Vista: selección de app -->
<sw-app-selector
  *ngIf="user && appsInOrg.length > 0"
  [@fadeSlide]
  [user]="user"
  [apps]="appsInOrg"
  [loading]="loadingApps"
  (appSelected)="onAppSelected($event)"
  (logoutRequest)="onLogout()"
></sw-app-selector>

<!-- Modal: recuperación de contraseña -->
<sw-password-reset-modal
  [(visible)]="showResetModal"
  [email]="resetEmail"
  (resetSent)="showResetModal = false"
></sw-password-reset-modal>
